/**
 * Slot de rotas selecionado em build-time (plano de unificação, Fase 1).
 * Default: visual WEB. A configuration "mobile"/"mobile-production" do
 * angular.json substitui este arquivo por app.routes.app.ts (visual APP)
 * via fileReplacements.
 */
export { routes, visualProviders } from "./app.routes.web";
